import React, { FC } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, ModalClose, Box, Text, ButtonAppearance } from '@bechtel/gds';
import { DrawerFooterButtonStyled } from '@bechtel/client-common';
import { Trans, t } from '@lingui/macro';

interface ConfirmCancelProps {
  onCancel: () => void;
  onConfirm: () => void;
}

const ConfirmCancel: FC<ConfirmCancelProps> = ({ onCancel, onConfirm }) => {
  return (
    <Modal visible={true} style={{ width: '552px', height: '275px' }}>
      <ModalHeader title={t`Cancel Request`}>
        <ModalClose onClick={onCancel}></ModalClose>
      </ModalHeader>
      <ModalBody>
        <Box pl={{ sm: '500' }} pr={{ sm: '900' }} py={{ sm: '600' }}>
          <Text size="500" family="graphik" color="grey.1000">
            <Trans>Are you sure you want to cancel your crew change request?</Trans>
          </Text>
        </Box>
      </ModalBody>
      <ModalFooter>
        <Box justifyContent={{ sm: 'flex-end' }}>
          <Box mr={{ sm: '400' }}>
            <DrawerFooterButtonStyled appearance={ButtonAppearance.SECONDARY} onClick={onCancel}>
              <Trans>NO, LEAVE AS IS</Trans>
            </DrawerFooterButtonStyled>
          </Box>
          <Box>
            <DrawerFooterButtonStyled appearance={ButtonAppearance.SECONDARY} onClick={onConfirm}>
              <Trans>YES, CANCEL REQUEST</Trans>
            </DrawerFooterButtonStyled>
          </Box>
        </Box>
      </ModalFooter>
    </Modal>
  );
};

export default ConfirmCancel;
